/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  SvgIcon,
  Button,
} from '../'

export class ButtonDropdown extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired
      })
    ).isRequired,
    minWidth: PropTypes.number,
    stopPropagation: PropTypes.bool
  }

  static defaultProps = {
    id: 'buttonDropDown',
    minWidth: 85
  }

  constructor(props) {
    super(props)

    this.state = {
      open: false
    }

    this.buttonDropdownRef = React.createRef()
  }

  componentDidMount() {
    document.addEventListener("click", this.listenForClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.listenForClickOutside)
  }

  listenForClickOutside = (e) => {
    if (this.buttonDropdownRef.current.contains(e.target)) {
      // click is inside, stay open
      return
    }

    // click outside
    this.setState({ open: false })
  }

  render() {
    return (
      <div
        id={this.props.id}
        ref={this.buttonDropdownRef}
        className={`slds-dropdown-trigger slds-dropdown-trigger_click ${this.state.open ? 'slds-is-open' : ''}`}>
        <Button
          type={this.state.open ? 'brand' : 'default'}
          minWidth={this.props.minWidth}
          onClick={e => {
            if (this.props.stopPropagation) {
              e.stopPropagation()
            }
            this.setState(prevState => ({ open: !prevState.open }))
          }}>
          {this.props.label}
          <SvgIcon
            variant='utility'
            symbol='chevrondown'
            size='xx-small'
            colour={this.state.open ? 'inverse' : 'success'}
            className='slds-m-left_xx-small'
          />
        </Button>
        <div className='slds-dropdown slds-dropdown_right'>
          <ul className="slds-dropdown__list" role="menu">
            {this.props.options.map((option, index) => (
              <li
                className="slds-dropdown__item"
                onClick={e => {
                  if (this.props.stopPropagation) {
                    e.stopPropagation()
                  }
                  this.setState({ open: false })
                  option.onClick()
                }}
                role="presentation"
                key={`button-dropdown_${option.label}`}>
                <a role="menuitem" tabIndex={index}>
                  <span className="slds-truncate">
                    {option.label}
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/button-dropdown/index.js